<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <form id="createSection" @submit="createSection" >
          <CCardHeader>
            <CCol col="6" style="font-size: 25px;">إضافة وحدة جديدة</CCol>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm='6'>
                <div class='form-group'>
                    <label for='categories'>
                      التصنيفات
                      <span class='star'>*</span>
                    </label>
                    <div>
                      <multiselect
                        class='required'
                        v-model='selectedCategory'
                        id='categories'
                        @select="onCategoriesChange($event)"
                        :options='categories'
                        :searchable='true'
                        selectedLabel=' العنصر المحدد'
                        deselectLabel='اضغط لإلغاء اختيار هذا العنصر'
                        selectLabel='اضغط لإختيار هذا العنصر'
                        :close-on-select='true'
                        placeholder=' اختر التصنيف المناسبة '
                        label='name'
                        track-by='name'
                        required='required'
                      >
                        <span slot='noOptions'>اللائحة فارغة</span>
                        <span slot='noResult'>لا توجد نتيجة</span>
                      </multiselect>
                      <div v-if(errors.category_id) class="invalid-feedback">
                        {{errors.category_id}}
                      </div>
                    </div>
                  </div>
              </CCol>
              <CCol sm='6'>
                <div class='form-group'>
                    <label for='subCategories'>
                      التصنيفات الفرعية
                      <span class='star'>*</span>
                    </label>
                    <div>
                      <multiselect
                        class='required'
                        v-model='selectedSubCategory'
                        @select="onSubCategoriesChange($event)"
                        id='subCategories'
                        :options='subCategories'
                        :searchable='true'
                        selectedLabel=' العنصر المحدد'
                        deselectLabel='اضغط لإلغاء اختيار هذا العنصر'
                        selectLabel='اضغط لإختيار هذا العنصر'
                        :close-on-select='true'
                        placeholder=' اختر التصنيف الفرعية المناسبة '
                        label='name'
                        track-by='name'
                        required='required'
                      >
                        <span slot='noOptions'>اللائحة فارغة</span>
                        <span slot='noResult'>لا توجد نتيجة</span>
                      </multiselect>
                      <div v-if(errors.sub_category_id) class="invalid-feedback">
                        {{errors.sub_category_id}}
                      </div>
                    </div>
                  </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm='6'>
                <div class='form-group'>
                    <label for='courses'>
                      الكورس
                      <span class='star'>*</span>
                    </label>
                    <div>
                      <multiselect
                        class='required'
                        v-model='selectedCourse'
                        id='courses'
                        :options='courses'
                        :searchable='true'
                        selectedLabel=' العنصر المحدد'
                        deselectLabel='اضغط لإلغاء اختيار هذا العنصر'
                        selectLabel='اضغط لإختيار هذا العنصر'
                        :close-on-select='true'
                        placeholder=' اختر الكورس '
                        label='name'
                        track-by='name'
                        required='required'
                      >
                        <span slot='noOptions'>اللائحة فارغة</span>
                        <span slot='noResult'>لا توجد نتيجة</span>
                      </multiselect>
                      <div v-if(errors.course_id) class="invalid-feedback">
                        {{errors.course_id}}
                      </div>
                    </div>
                  </div>
              </CCol>
            </CRow>
            <hr/>
            <CRow>
              <CCol sm="6">
                <CInput label="English Name"
                  id="name"
                  v-model="section.name"
                  class="required"
                  placeholder=" أدخل إسم الوحدة بالانجليزية"
                  :invalidFeedback="errors.name"
                  required
                />
              </CCol>
              <CCol sm="6">
                <CInput label="الاسم"
                  id="name"
                  v-model="section.name_ar"
                  class="required"
                  placeholder="أدخل إسم الوحدة بالعربي"
                  :invalidFeedback="errors.name_ar"
                  required
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea
                  label='الوصف (اختياري)'
                  placeholder='المحتوى  بالإنجليزية'
                  horizontal
                  rows='4'
                  v-model='section.description'
                  :invalidFeedback="errors.description"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea
                  label='الوصف (اختياري)'
                  placeholder='المحتوى بالعربي'
                  horizontal
                  rows='4'
                  v-model='section.description_ar'
                  :invalidFeedback="errors.description_ar"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter>
            <CButton type="submit" size="sm" color="primary" ><CIcon name="cil-check-circle"/> حفظ</CButton>
              &emsp;
            <CButton type="reset" size="sm" color="danger"><CIcon name="cil-ban"/> مسح </CButton>
          </CCardFooter>
          </form>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import $ from 'jquery'
import swal from 'sweetalert'
export default {
  name: 'CreateSection',
  data: function () {
    return {
      section: {},
      courses: [],
      selectedCourse: '',
      subCategories: [],
      selectedSubCategory: '',
      categories: [],
      selectedCategory: '',
      errors: []
    }
  },
  created () {
    const categories = []
    const subCategories = []
    const courses = []
    this.$http
      .get(`${this.$hostUrl}sections/create`)
      .then((response) => {
        $.each(response.data.data.categories, function (key, value) {
          categories.push({ id: value.id, name: value.name_ar })
        })
        this.categories = categories
        $.each(response.data.data.subCategories, function (key, value) {
          subCategories.push({ id: value.id, name: value.name_ar })
        })
        this.subCategories = subCategories
        $.each(response.data.data.courses, function (key, value) {
          courses.push({ id: value.id, name: value.name_ar })
        })
        this.courses = courses
      })
  },
  methods: {
    onCategoriesChange ($event) {
      const subCategories = []
      this.$http
        .get(
            `${this.$hostUrl}categories/${$event.id}/sub-categories`
        )
        .then((response) => {
          $.each(response.data.data, function (key, value) {
            subCategories.push({ id: value.id, name: value.name_ar })
          })
          this.subCategories = subCategories
        })
    },
    async createSection (e) {
      e.preventDefault()
      const formData = new FormData()
      if (this.selectedCourse) {
        formData.append('course_id', this.selectedCourse.id)
      } else {
        this.errors.push('course_id')
        this.errors.course_id = 'course field is required'
        swal('يرجى تحديد الكورس')
        return 0
      }
      if (/^\d+$/.test(this.section.name)) {
        swal('اسم الوحدة يجب ان يحتوي على حروف')
        return 0
      }
      if (/^\d+$/.test(this.section.name_ar)) {
        swal('اسم الوحدة يجب ان يحتوي على حروف')
        return 0
      }
      formData.append('name', this.section.name)
      formData.append('name_ar', this.section.name_ar)
      if (this.section.description) {
        formData.append('description', this.section.description)
      }
      if (this.section.description_ar) {
        formData.append('description_ar', this.section.description_ar)
      }
      this.errors = await this.postRequest(formData, this.$hostUrl + 'sections', '/sections')
    }
  }
}

</script>
